
document.addEventListener('DOMContentLoaded', e => {
    initProductQuantity();
});
function initProductQuantity() {
    let debounceTimer;

    const triggerCartUpdate = () => {
        //For cart page 
        if (document.body.classList.contains('woocommerce-cart') || document.querySelector('form.woocommerce-cart-form')) {
            const updateButton = document.querySelector('[name="update_cart"]');
            if (updateButton && !updateButton.disabled) {
                updateButton.click();
            }
        }
    };

    // "+" and "-"
    document.addEventListener('click', function (e) {
        const plus = e.target.closest('.quantity__plus');
        const minus = e.target.closest('.quantity__minus');

        if (!plus && !minus) return;

        const fieldGroup = e.target.closest('.quantity');
        if (!fieldGroup) return;

        const input = fieldGroup.querySelector('.quantity__input');
        if (!input) return;

        let currentValue = parseInt(input.value, 10) || 0;

        if (plus) {
            input.value = currentValue + 1;
        } else if (minus && currentValue > 1) {
            input.value = currentValue - 1;
        }
        input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    document.addEventListener('change', function (e) {
        if (e.target.matches('.quantity__input')) {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(triggerCartUpdate, 750);
        }
    });
}
